import { Link } from 'react-router-dom';
import TutelaLogo from '../icons/TutelaLogo';

/**
 * Site-wide footer (dark "data-instrument" chrome). Rendered by App on every
 * route except the full-viewport app surfaces (maps, consoles). Two products,
 * the municipal offer, open data and the company, so every page cross-links
 * the parts of the site that used to be reachable only from the landing.
 */
export default function SiteFooter() {
  const cols: { title: string; items: { label: string; to?: string; href?: string }[] }[] = [
    {
      title: 'Produtos',
      items: [
        { label: 'IGNIS · risco de incêndio', to: '/ignis' },
        { label: 'LIMES · faixas de combustível', to: '/limes' },
      ],
    },
    {
      title: 'Municípios',
      items: [
        { label: 'Para municípios', to: '/municipios' },
        { label: 'Pilotos', to: '/pilotos' },
      ],
    },
    {
      title: 'Dados',
      items: [
        { label: 'Validação pública', to: '/ignis/validacao' },
        { label: 'Arquivo de previsões', href: 'https://github.com/neuralforge-pt/tutela-ignis' },
      ],
    },
    {
      title: 'Empresa',
      items: [
        { label: 'Sobre', to: '/sobre' },
        { label: 'Neural Forge', href: 'https://neuralforge.pt/' },
      ],
    },
  ];

  return (
    <footer className="border-t border-ink-800 bg-ink-950 text-mist">
      <div className="mx-auto max-w-6xl px-6 py-16">
        <div className="flex flex-col justify-between gap-10 lg:flex-row lg:items-start">
          <div className="max-w-sm">
            <div className="mb-4 flex items-center gap-3">
              <TutelaLogo className="h-10 w-10" variant="light" />
              <div className="leading-tight">
                <div className="font-display text-lg font-bold">Tutela</div>
                <div className="font-mono text-xs uppercase tracking-[0.2em] text-mist-faint">
                  Stewards of Tomorrow
                </div>
              </div>
            </div>
            <p className="text-sm leading-relaxed text-mist-muted">
              Proteção ambiental orientada por aprendizagem automática. Previsão de risco de
              incêndio para todo o país e priorização da gestão de combustível para os municípios.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-4 lg:gap-12">
            {cols.map((c) => (
              <div key={c.title}>
                <h4 className="mb-3 font-mono text-xs uppercase tracking-widest text-mist-faint">
                  {c.title}
                </h4>
                <ul className="space-y-2 text-sm text-mist-muted">
                  {c.items.map((it) => (
                    <li key={it.label}>
                      {it.to ? (
                        <Link to={it.to} className="transition-colors hover:text-mist">
                          {it.label}
                        </Link>
                      ) : (
                        <a
                          href={it.href}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="transition-colors hover:text-mist"
                        >
                          {it.label}
                        </a>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-ink-800 pt-8 font-mono text-xs text-mist-faint sm:flex-row">
          <a href="mailto:hello@tutela.land" className="transition-colors hover:text-mist">
            hello@tutela.land · Santa Clara-a-Nova, Portugal
          </a>
          <p>© 2026 Tutela · Neural Forge</p>
        </div>
      </div>
    </footer>
  );
}
